var map = {
	"./ar.svg": "3257",
	"./bg.svg": "5d97",
	"./de.svg": "94f0",
	"./en.svg": "eff4",
	"./et.svg": "0c27",
	"./fi.svg": "4b39",
	"./he.svg": "7fea",
	"./hr.svg": "3eaa",
	"./is.svg": "2815",
	"./mapIcons/artilleryLeft.svg": "ba2b",
	"./mapIcons/artilleryRight.svg": "d5d7",
	"./mapIcons/bomb.svg": "11ca",
	"./mapIcons/gunLeft.svg": "ae19",
	"./mapIcons/gunRight.svg": "3e27",
	"./mapIcons/tankLeft.svg": "82c1",
	"./mapIcons/tankRight.svg": "c7d4",
	"./nl.svg": "8eb4",
	"./pl.svg": "84e4",
	"./ru.svg": "cb8a",
	"./sh.svg": "2642",
	"./sv.svg": "9b8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";